export interface Config {
  serverUrl: string
}

const env = (window as any).env

export const config: Config = {
  serverUrl: 'https://drome.antogin.dev',
}
